<template>
  <v-dialog v-model="internalShow" width="700">
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        Detail
      </v-card-title>

      <div v-if="detailData" style="text=align:center;margin-left:10%;padding:20px;">
        <table>
          <tr>
            <td>Date</td>
            <td>{{ displayDateTime(detailData && detailData.date) }}</td>
          </tr>
          <tr>
            <td>Status</td>
            <td>{{ getStatus(detailData && detailData.status) }}</td>
          </tr>
          <tr v-show="detailData && detailData.type == 1">
            <td>Duration</td>
            <td>{{ secondsToHms(detailData && detailData.duration) }}</td>
          </tr>
          <tr>
            <td>Type</td>
            <td>
              <span v-if="detailData && detailData.type == 1">By Phone</span>
              <span v-else-if="detailData && detailData.type == 2">In Person</span>
              <span v-else-if="detailData && detailData.type == 3">INNO DOT</span>
              <span v-else>Unknown</span>
            </td>
          </tr>
          <tr v-show="detailData && detailData.type == 2 && detailData.signature">
            <td>Signature</td>
            <td>
              <img
                class="materialboxed"
                :src="'data:image/png;base64, ' + (detailData && detailData.signature)"
                alt
                style="width:200px;height:200px;"
              />
            </td>
          </tr>
        </table>
      </div>
      <div v-else style="padding: 24px;">No detail to display.</div>

      <div
        class="row side_effect_container"
        v-show="detailData && detailData.status == 1"
        style="margin-left:10%;"
      >
        <h4>Side Effect</h4>
        <p style="margin-left:20px;">{{ detailData && detailData.low_side_effect }}</p>
      </div>
      <div
        class="row side_effect_container"
        v-show="detailData && detailData.status == 1"
        style="margin-left:10%;"
      >
        <h4>Action</h4>
        <p style="margin-left:90px;">{{ detailData && detailData.high_side_effect }}</p>
      </div>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="internalShow = false">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  
</template>

<script>
export default {
  props: ["show", "detailData"],
  computed: {
    internalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      }
    }
  },
  methods: {
    getStatus(id) {
      switch (parseInt(id)) {
        case 1:
          return "Visited";
        case 2:
          return "Cannot call";
        case 0:
          return "Pending";
        default:
          return "Unknown";
      }
    },
    secondsToHms(d) {
      d = Number(d || 0);
      var h = Math.floor(d / 3600);
      var m = Math.floor((d % 3600) / 60);
      var s = Math.floor((d % 3600) % 60);
      var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
      var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
      var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
      return (hDisplay + mDisplay + sDisplay) || "0 seconds";
    },
    displayDateTime(v) {
      if (!v) return "-";
      const date = new Date(v);
      const current_date = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
      const current_time = date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
      return current_date + " " + current_time;
    },
  },
};
</script>

<style scoped>
.side_effect_container {
  padding: 20px;
}
</style>


